import {
  FormGroupControls,
  AllValidationErrors,
} from "../model/AllValidationErrors";
import { FormGroup, ValidationErrors } from "@angular/forms";
import { MessageModel } from "../model/MessageModel";
import { ApplicantService } from "../service/applicant.service";
import { CookiesLocalService } from "../service/cookies-local.service";
import { IApplicant } from "../model/IApplicant";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";

export class ComponentBase {
  public isDoneLoading = true;
  programmeMessage: MessageModel;
  imageUploadMessage: MessageModel;
  personalMessage: MessageModel;
  examinationMessage: MessageModel;
  applicantData: IApplicant;

  public showLoadingIndicator = true;

  error = "";

  errrorMessage;

  constructor(
    public applicantService: ApplicantService,
    public cookieLocal: CookiesLocalService,
    public behaviorModelChangeService: BehaviorModelChangeService
  ) {
    this.getApplicantAllData();
  }

  isPostgraduateStudent() {
    return (
      this.applicantData.ApplicationTypeId === 7 ||
      this.applicantData.ApplicationTypeId === 8
    );
  }

  isCertificateStudent() {
    return (
      this.applicantData.ApplicationTypeId === 5 ||
      this.applicantData.ApplicationTypeId === 6 ||
      this.applicantData.ApplicationTypeId === 9
    );
  }

  isDiplomaStudent() {
    return (
      this.applicantData.ApplicationTypeId === 3 ||
      this.applicantData.ApplicationTypeId === 4
    );
  }

  isForignStudent() {
    // return this.applicantData.ApplicationTypeId==2 ||
    // this.applicantData.ApplicationTypeId==4 ||
    // this.applicantData.ApplicationTypeId==6 ||
    // this.applicantData.ApplicationTypeId==8 ||
    // this.applicantData.ApplicationTypeId==9 ;
    // console.log(this.applicantData.IsForignStudent);

    return this.applicantData.IsForignStudent;
  }

  getApplicantAllData() {
    if (
      !this.applicantService ||
      !this.cookieLocal ||
      !this.behaviorModelChangeService
    ) {
      return;
    }

    this.applicantData = this.cookieLocal.getApplicantData();

    this.applicantService
      .getApplicant(this.applicantData.StudentNumber)
      .subscribe((st) => {
        this.cookieLocal.getRefreshedApplicantData(st);

        // checking student picture
        const image = st.PhotoUrl;

        if (image.indexOf("default") <= 0) {
          this.imageUploadMessage = { message: "Completed (100%)", value: 20 };
        } else {
          this.imageUploadMessage = { message: "Incomplete (0%)", value: 0 };
        }

        // checking student bio
        if (st.FirstName && st.LastName) {
          this.personalMessage = { message: "Completed (100%)", value: 20 };
        } else {
          this.personalMessage = { message: "Incomplete (0%)", value: 0 };
        }

        this.applicantService
          .getApplicantExaminations(this.applicantData.ApplicationId)
          .subscribe((data) => {
            const examinationData = data;
            this.cookieLocal.getRefreshedApplicantExamination(data);

            if (examinationData.length > 0) {
              this.examinationMessage = {
                message: "Completed (100%)",
                value: 20,
              };
            } else {
              this.examinationMessage = {
                message: "Incomplete (0%)",
                value: 0,
              };
            }

            this.applicantService
              .geApplicantProgrammeOfChoice(this.applicantData.ApplicationId)
              .subscribe((val) => {
                const applicantProgrammeLocal = val.SelectedProgrammes.filter(
                  (a) =>
                    a.ApplicantProgrammeOfChoiceId != null ||
                    a.ApplicantProgrammeOfChoiceId != undefined
                );
                this.cookieLocal.getRefreshedApplicantProgrammeOfChoice(val);

                if (applicantProgrammeLocal.length > 0) {
                  this.programmeMessage = {
                    message: "Completed (100%)",
                    value: 20,
                  };
                } else {
                  this.programmeMessage = {
                    message: "Incomplete (0%)",
                    value: 0,
                  };
                }

                const model: MessageModel[] = [
                  this.imageUploadMessage,
                  this.personalMessage,
                  this.examinationMessage,

                  this.programmeMessage,
                ];

                this.cookieLocal.getRefreshedProgressMessageData(model);

                this.behaviorModelChangeService.onUpdateProgressBar(model);
              });
          });
      });
  }

  getFormValidationErrors(controls: FormGroupControls): AllValidationErrors[] {
    let errors: AllValidationErrors[] = [];
    Object.keys(controls).forEach((key) => {
      const control = controls[key];
      if (control instanceof FormGroup) {
        errors = errors.concat(this.getFormValidationErrors(control.controls));
      }
      const controlErrors: ValidationErrors = controls[key].errors;
      if (controlErrors !== null) {
        Object.keys(controlErrors).forEach((keyError) => {
          errors.push({
            control_name: key,
            error_name: keyError,
            error_value: controlErrors[keyError],
          });
        });
      }
    });
    return errors;
  }

  onChange(formGroup: FormGroup): any {
    if (!formGroup.valid) {
      const error: AllValidationErrors = this.getFormValidationErrors(
        formGroup.controls
      ).shift();
      if (error) {
        let text;
        switch (error.error_name) {
          case "required":
            text = `${error.control_name} is required!`;
            break;
          case "pattern":
            text = `${error.control_name} has wrong pattern!`;
            break;
          case "email":
            text = `${error.control_name} has wrong email format!`;
            break;
          case "minlength":
            text = `${error.control_name} has wrong length! Required length: ${error.error_value.requiredLength}`;
            break;
          case "areEqual":
            text = `${error.control_name} must be equal!`;
            break;
          default:
            text = `${error.control_name}: ${error.error_name}: ${error.error_value}`;
        }
        this.error = text;
      }
      return;
    }
  }
}
